import { createFileRoute } from '@tanstack/react-router';

import {
  loadSimulationMessages,
  loadSimulationOffersScreens,
  simulationInssPayrollNewScreen,
} from '@/modules/simulation/route';
import { flowSearchSchema } from '@/shared/flow/define-flow';
import { lazyScreen } from '@/shared/screen/lazy-screen';

// Consignado INSS novo no caminho do legado (`router.tsx:1182-1186`, `resource='ConsignadoInss'`): o passo vai em
// `?passo=`. Arquivo leve (JS inicial); a tela vem em chunk próprio.
export const Route = createFileRoute('/_app/ccb/contratar/consignado-inss/novo/')({
  validateSearch: flowSearchSchema(),
  staticData: { screen: simulationInssPayrollNewScreen },
  loader: () => loadSimulationMessages(),
  component: lazyScreen(loadSimulationOffersScreens, 'InssPayrollRouteScreen'),
});
